import React from 'react'
import { FormDashboardInputPercent, FormDashboardInput } from '../../../components';
import { viewportBreakpoint, useViewport } from '../../../utils';

const Row = ({data}) => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <tr>
      <td className="align-top">
        <div className="py-2 lg:py-0" style={{maxWidth: isMobile ? '90px' : '180px'}}>
          <FormDashboardInput defaultValue={data.name} className="w-full"/>
        </div>
      </td>
      <td>
        <div className="py-1 lg:py-0 lg:-my-2">
          <div className="flex items-center justify-between mb-3">
            <div className="mr-2">Baseline</div>
            <div style={{maxWidth: isMobile ? '60px' : '110px'}}>
              <FormDashboardInputPercent small={isMobile ? true : false}/>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="mr-2">Endline</div>
            <div style={{maxWidth: isMobile ? '60px' : '110px'}}>
              <FormDashboardInputPercent small={isMobile ? true : false}/>
            </div>
          </div>
        </div>
      </td>
      <td className="relative align-top">
        <div className="flex justify-end py-2 lg:py-0">
          <p className="cursor-pointer underline text-sm text-gray-999">Delete</p>
        </div>
      </td>
    </tr>
  )
}

const SurveyInput = () => {
  return (
    <table className="table table--striped">
      <tbody className="text-sm">
        <Row data={{name: 'Bandung'}}/>
        <Row data={{name: 'Jakarta'}}/>
        <Row data={{name: 'Bandung'}}/>
        {/* <tr>
          <td colSpan={3} className="lg:text-right">
            <p className="link">+ Add City</p>
          </td>
        </tr> */}
      </tbody>
    </table>
  )
}

export { SurveyInput }